export default function credentials(builder) {
  return {
    getCredentialTypes: builder.query({
      query: () => '/credentials',
    }),
  };
}
